import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconDealsSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="dealsSolid">
            {/* The glyph is 24x23 and sits top-aligned in the 24x24 box, matching the design system
                (24pt/ic_deals_solid) and the outline IconDeals24 it swaps places with. */}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.83244 23L12 21.3436L16.1676 23L18.266 19.1243L22.5526 17.7863L21.6 13.5048L24 9.79851L20.4421 7.11453L19.8324 2.77414L15.334 2.94359L12 0L8.66595 2.94359L4.16756 2.77414L3.5579 7.11453L0 9.79851L2.4 13.5048L1.44738 17.7863L5.73405 19.1243L7.83244 23ZM11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19ZM16.7072 8.70716L8.70722 16.7072L7.29301 15.293L15.293 7.29295L16.7072 8.70716ZM9 8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8ZM17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C16.5523 15 17 15.4477 17 16Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
